module.exports = __webpack_public_path__ + "static/media/pregunta-frecuentes.2344ce4a.png";